import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-under-18-modal',
  templateUrl: './under-18-modal.component.html',
  styleUrls: ['./under-18-modal.component.css']
})
export class Under18ModalComponent implements OnInit {
  isIneligibleState = false;
  isTerritoryRestriction = false;
  isInternationalRestriction = false;
  isCommissionerAgeIneligible = false;
  stateName = '';
  detectedState = '';
  detectedStateName = '';
  countryCode = '';

  constructor(
    public dialogRef: MatDialogRef<Under18ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data && data.type === 'ineligible_state') {
      this.isIneligibleState = true;
      this.stateName = data.stateName || '';
    } else if (data && data.type === 'territory_restriction') {
      this.isTerritoryRestriction = true;
      this.stateName = data.stateName || '';
      this.detectedState = data.detectedState || '';
      this.detectedStateName = data.detectedStateName || data.detectedState || '';
    } else if (data && data.type === 'international_restriction') {
      this.isInternationalRestriction = true;
      this.countryCode = data.countryCode || '';
      this.stateName = data.stateName || '';
    } else if (data && data.type === 'commissioner_age_ineligible') {
      // SG-177 Phase 7: age < 18 while trying to create a Commissioner private contest
      this.isCommissionerAgeIneligible = true;
    }
  }

  ngOnInit(): void {
  }

  /**
   * Handle back to gaming lobby button click
   */
  onBackToLobby(): void {
    this.dialogRef.close({ action: 'back_to_lobby' });
  }

  /**
   * Close modal
   */
  close(): void {
    this.dialogRef.close({ action: 'closed' });
  }
}
